import type {TableConfiguration} from 'schema/table/types';
import type {NorafUpdatesIgnoreListItem} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';

export const norafUpdateIgnorelistItemTableConfig: TableConfiguration<NorafUpdatesIgnoreListItem> =
  {
    ...defaultTableConfig,
    defaultColumns: [
      {
        name: 'agentId',
        visible: false,
      },
      {
        name: 'id',
        visible: false,
      },
    ],
    disableSorting: true,
    enableSelectionButton: 'multiple',
  };
